export function inertElements(arrayElements, inertStatus) {
    arrayElements.forEach(selector => {
        let itemIndex = 0
        const $items = document.querySelectorAll(selector)

        while (itemIndex < $items.length) {
            const $item = $items[itemIndex]
            $item.inert = inertStatus
            itemIndex++
        }
    })
}
